import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";
import SummaryApi from "../common";
import { toast } from "react-toastify";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(SummaryApi.contactForm.url, {
        method: SummaryApi.contactForm.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.status) {
        toast.success("Thank you! We'll get back to you soon.");
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        toast.error(result.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Hero */}
      <section className="bg-[#001f3f] dark:bg-[#111827]  py-20 text-white text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-extrabold mb-4">Get In Touch</h1>
          <p className="text-xl opacity-90">
            Have questions? We're here to help you succeed.
          </p>
        </div>
      </section>

      <section className="py-16 px-6 bg-gray-50 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700">
            <h2 className="text-3xl font-bold text-blue-900 dark:text-white mb-6">
              Send us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <input
                type="text"
                name="name"
                placeholder="Your Name *"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full px-5 py-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email *"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-5 py-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-5 py-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition"
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject *"
                required
                value={formData.subject}
                onChange={handleChange}
                className="w-full px-5 py-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition"
              />
              <textarea
                name="message"
                rows="6"
                placeholder="Your Message *"
                required
                value={formData.message}
                onChange={handleChange}
                className="w-full px-5 py-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition resize-none"
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#1f4774] dark:bg-blue-600 text-white hover:bg-blue-800  font-semibold py-4 rounded-lg flex items-center justify-center gap-3 transition disabled:opacity-70"
              >
                {loading ? "Sending..." : "Send Message"}
                {!loading && <FaPaperPlane />}
              </button>
            </form>
          </div>

          {/* Contact Info + Map */}
          <div className="space-y-10">
            <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700">
              <h3 className="text-2xl font-bold text-blue-900 dark:text-white mb-6">
                Contact Information
              </h3>
              <div className="space-y-6 text-gray-700 dark:text-gray-300">
                <div className="flex items-start gap-4">
                  <FaMapMarkerAlt className="text-3xl text-blue-600 dark:text-blue-400" />
                  <div>
                    <p className="font-semibold">Office Address</p>
                    <p className="mt-1">
                      4th Floor, MKR Enclave,<br />
                      Kamayyathopu Pantakaluva Road, NTR Marg,<br />
                      Kanuru, Vijayawada, Andhra Pradesh 520007
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <FaPhoneAlt className="text-3xl text-green-600 dark:text-green-400" />
                  <div>
                    <p className="font-semibold">Call Us</p>
                    <p>+1 833 564 3321 (Toll Free)</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <FaEnvelope className="text-3xl text-purple-600 dark:text-purple-400" />
                  <div>
                    <p className="font-semibold">Email Us</p>
                    <p>contact@Skillara.org</p>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;